<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{
          $t('school.academic.operation.profile_mgt.teacher_profile.page_title')
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'school.academic.operation.profile_mgt.teacher_profile.page_title'
            ),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-between">
          <div class="ts-flex">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'teacher-profile-create' })"
              >{{ $t('add_new') }}</ts-button
            >
            <div
              class="ml-2 ts-rounded ts-border ts-px-2 ts-whitespace-no-wrap mr-2"
            >
              <div class="radio radio-css radio-inline">
                <input
                  v-model="side"
                  type="radio"
                  id="front"
                  :value="'front'"
                />
                <label for="front">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.front'
                    )
                  }}
                </label>
              </div>
              <div class="radio radio-css radio-inline">
                <input v-model="side" type="radio" id="back" :value="'back'" />
                <label for="back">
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.teacher_profile.back'
                    )
                  }}
                </label>
              </div>
              <!-- Old Preview Card  -->
              <ts-button
                v-if="true"
                class="btn-sm ml-2 mr-3"
                :disabled="!checkedTeacher.length > 0"
                outline
                color="primary"
                @click="previewCard('simple')"
              >
                {{
                  $t(
                    'school.academic.operation.profile_mgt.teacher_profile.previewCard'
                  )
                }}
              </ts-button>
            </div>
            <!-- New Preview Card -->
            <div class="ts-mr-2" v-if="false">
              <b-dropdown
                dropdown
                :text="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.previewCard'
                  )
                "
                variant="primary"
              >
                <b-dropdown-item
                  :disabled="!checkedTeacher.length > 0"
                  href="#"
                  @click="previewCard('simple')"
                >
                  <i class="fas fa-print"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.simplePrinter'
                    )
                  }}
                </b-dropdown-item>
                <b-dropdown-item
                  :disabled="!checkedTeacher.length > 0"
                  href="#"
                  @click="previewCard('pro')"
                >
                  <i class="fas fa-id-card"></i>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.proPrinter'
                    )
                  }}
                </b-dropdown-item>
              </b-dropdown>
            </div>

            <b-dropdown
              dropdown
              :text="
                $t(
                  'school.academic.operation.profile_mgt.teacher_profile.exportExcel'
                )
              "
              variant="outline-success"
              :waiting="exporting"
            >
              <b-dropdown-item
                :disabled="!checkedTeacher.length > 0"
                href="#"
                @click="exportExcelSelectedTeacher"
              >
                <i class="fas fa-check-square"></i>
                {{
                  $t(
                    'school.academic.operation.profile_mgt.teacher_profile.selectedTeacher'
                  )
                }}
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="exportExcelAllTeacher">
                <i class="fas fa-users"></i>
                {{
                  $t(
                    'school.academic.operation.profile_mgt.teacher_profile.allTeacher'
                  )
                }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="ts-flex ts-justify-end">
            <div class="mr-2">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 300px"
              />
            </div>
            <ts-button
              outline
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table
            :columns="columns"
            :data="resources"
            :loading="loading"
            max-height="700"
            stripe
            highlight-row
            size="small"
            ref="selection"
            @on-select="onSelectCheck"
            @on-select-cancel="onSelectUncheck"
            @on-select-all="onSelectAllCheck"
            @on-select-all-cancel="onSelectAllUncheck"
          >
            <template slot-scope="{ row }" slot="photo">
              <img
              class="height-40 ts-rounded"                
                v-lazy="{
                  src: teacherPhoto(row),
                  error: onError(row),
                  loading: require('@/assets/Rolling-1s-200px_2.svg')
                }"
              />
            </template>
            <template slot-scope="{ row }" slot="gender">
              {{ gender(row.gender) }}
            </template>
            <template slot-scope="{ row }" slot="reg_type">
              {{
                row.registeration_type ? row.registeration_type.reg_type : ''
              }}
            </template>
            <template slot-scope="{ row }" slot="teacher_pos_id">
              {{ position(row.teacher_pos_id) }}
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="mr-2 text-primary"
                @click.prevent="edit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="
                  $t(
                    'school.academic.operation.profile_mgt.teacher_profile.schedule'
                  )
                "
                class="mr-2 text-primary"
                @click.prevent="schedule(row)"
              >
                <i class="far fa-calendar-alt"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger mr-1"
                @click.prevent="destroy(row)"
                :disabled="row._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>

              <Dropdown
                trigger="click"
                v-tooltip="
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.card'
                  )
                "
                style="margin-left: 10px"
                @on-click="name => card(row, 'front')"
              >
                <i class="fas fa-id-card"></i>
                <DropdownMenu slot="list">
                  <DropdownItem name="front"
                    ><i class="fas fa-address-card"></i>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.frontCard'
                      )
                    }}</DropdownItem
                  >
                  <DropdownItem name="back" @click="card(row, 'back')"
                    ><i class="far fa-credit-card"></i>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.backCard'
                      )
                    }}</DropdownItem
                  >
                </DropdownMenu>
              </Dropdown>
            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <!-- drawer -->
    <a-drawer
      :title="$t('invoice.filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div style="font-size: 12px">
        <div class="row">
          <legend class="text-black ts-text-sm">
            {{ $t('teacherprofile.photoUpload') }}
          </legend>
          <div class="form-group">
            <div class="radio radio-css radio-inline is-valid">
              <input
                v-model="photo_exists"
                type="radio"
                id="uploaded"
                :value="'yes'"
              />
              <label for="uploaded">
                {{ $t('teacherprofile.uploaded') }}
              </label>
            </div>
            <div class="radio radio-css radio-inline is-invalid">
              <input
                v-model="photo_exists"
                type="radio"
                id="no_upload"
                :value="'no'"
              />
              <label for="no_upload">
                {{ $t('teacherprofile.notYetUpload') }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { debounce, trim } from 'lodash'
import { mapState } from 'vuex'
import ScheduleComponent from './schedule'
import PreviewCard from './preview-card'
import * as FileDownload from 'downloadjs'

export default {
  name: 'teacher-profile',
  data () {
    return {
      loading: false,
      visible: false,
      exporting: false,
      side: 'front',
      checkedTeacher: [],
      man: require('../../assets/staff-default-man.png'),
      woman: require('../../assets/staff-default-women.png')
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('teacherProfile', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.teacherProfile.search
      },
      set (newValue) {
        this.$store.commit('teacherProfile/SET_SEARCH', newValue)
        this.$store.commit('teacherProfile/RESET_CURRENT_PAGE')
      }
    },
    photo_exists: {
      get () {
        return this.$store.state.teacherProfile.photo_exists
      },
      set (newValue) {
        this.$store.commit('teacherProfile/SET_PHOTO_EXISTS', newValue)
      }
    },
    columns () {
      return [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.teacher_id'
          ),
          key: 'teacher_code',
          minWidth: 60

        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.photo'
          ),
          slot: 'photo',
          minWidth: 40

        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.last_name_en'
          ),
          key: 'lname_foreign',
          minWidth: 100
          
        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.first_name_en'
          ),
          key: 'fname_foreign',
          minWidth: 100

        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.gender'
          ),
          slot: 'gender',
          minWidth: 40,
          align: 'center',
        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.phone'
          ),
          key: 'phone',
          minWidth: 80

        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.register_type'
          ),
          slot: 'reg_type',
          minWidth: 80

        },
        {
          title: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.position'
          ),
          slot: 'teacher_pos_id',
          minWidth: 80

        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 200
        }
      ]
    },
    gender: () => gender => {
      if (gender === 1) return 'Male'
      if (gender === 2) return 'Female'
      return ''
    },
    position: () => position => {
      if (position === 1) return 'Teacher'
      if (position === 2) return 'Teacher Assistant'
      return ''
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'teacherProfile/fetch',
          Object.assign(
            {
              page: this.pagination.currentPage
            },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit (record) {
      this.$store.commit('teacherProfile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'teacher-profile-edit',
        params: { id: record.teacher_id }
      })
    },
    onSelectCheck (record) {
      this.checkItem(record)
    },
    onSelectUncheck (record) {
      this.checkItem(record)
    },
    onSelectAllCheck (record) {
      this.checkItem(record)
    },
    onSelectAllUncheck (record) {
      this.checkItem(record)
    },
    checkItem (value) {
      this.checkedTeacher = []
      if (!_.isEmpty(value)) {
        value.forEach(element => {
          this.checkedTeacher.push(element.teacher_id)
        })
      }
    },
    previewCard (type) {
      this.$modal.show(
        PreviewCard,
        {
          id_list: this.checkedTeacher,
          side: this.side,
          type: type
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    card (record, side) {
      this.checkedTeacher = []
      this.checkedTeacher.push(record.teacher_id)
      this.side = side
      this.previewCard()
      this.checkedTeacher = []
    },

    schedule (record) {
      this.$modal.show(
        ScheduleComponent,
        {
          teacher: record
        },
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          clickToClose: false
        }
      )
    },

    async destroy (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('teacherProfile/destroy', record.teacher_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    teacherPhoto (record) {
      if (record.photo) {
        return record.photo
      }
      return record.gender == 1 ? this.man : this.woman
    },
    onError (record) {
      event
        ? (event.target.src = record.gender == 1 ? this.man : this.woman)
        : ''
    },
    excel (record) {
      this.checkedTeacher = []
      this.checkedTeacher.push(record.teacher_id)
      this.exportExcelSelectedTeacher()
      this.checkedTeacher = []
    },
    exportExcelAllTeacher () {
      this.checkedTeacher = []
      this.exportExcelSelectedTeacher()
    },
    exportExcelSelectedTeacher () {
      this.exporting = true
      this.$store
        .dispatch('teacherProfile/exportExcel', {
          teacher_id: this.checkedTeacher
        })
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    photo_exists: debounce(function (photo_exists) {
      this.fetchData({ photo_exists })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'teacher-profile-create') {
      this.$store.commit('teacherProfile/RESET_STATE')
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
